import notifyError from '@/lib/notify-error';
import notifySuccess from '@/lib/notify-success';
import { findItem, updateItem } from '@/services/publicacao';
import { findDocumentos } from '@/services/documento';
import { createNotificacao } from '@/services/notificacao';
import Log from '@/services/log';
import Router from '@/router';

const Getters = {
  item(st) {
    return st.item;
  },
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  hasPermission(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name !== 'pesquisador') {
      return true;
    }
    return false;
  },
  account(st, gt, rSt) {
    return rSt.auth.account;
  },
  loading(st) {
    return st.loading;
  },
  documentos(st) {
    return st.documentos;
  },
  footerProps() {
    return {
      itemsPerPageOptions: [6, 12, 24, 48],
      showFirstLastPage: true,
    };
  },
  totalDocumentos(st) {
    return st.totalDocumentos;
  },
  options(st) {
    return st.options;
  },
  rejectedDialog(st) {
    return st.rejectedDialog;
  },
  notification(st) {
    return st.notification;
  },
  acervo(st) {
    return st.acervo;
  },
  globalSearch(st, gt, rSt) {
    return rSt.views.collection.list.globalSearch;
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setItem(state, item) {
    state.item = item;
  },
  setDocumentos(state, documentos) {
    state.documentos = documentos;
  },
  setTotalDocumentos(state, total) {
    state.totalDocumentos = total;
  },
  setOptions(state, options) {
    state.options = options;
  },
  setRejectedDialog(state, status) {
    state.rejectedDialog = status;
  },
  setNotification(state, notification) {
    state.notification = notification;
  },
  setAcervo(state, acervo) {
    state.acervo = acervo;
  },
};

const actions = {
  afterRouteUpdate({ dispatch, commit }, to) {
    commit('setItem', {});
    if (to.params.id) {
      dispatch('loadItem', to.params.id);
    }
  },
  loadItem({ commit, getters, dispatch }, id) {
    commit('setLoading', true);
    const settings = {
      include: [
        { suporteBase: ['suporteBaseIdTipoSuporteFkrel', 'suporteBaseEstadoFkrel'] },
        'tipoPublicacao',
        { segmento: 'idSegmentoFkrel' },
        { idioma: 'idIdiomaPubFkrel' },
        'palavrasChave',
        { tipoObjeto: 'idTipoobjetoFkrel' },
        { familias: 'familiaFkrel' },
        'publicador',
        {
          relation: 'notificacoes',
          scope: {
            include: 'admin',
            order: 'id DESC',
            limit: 1,
            where: {
              type: 'recusado',
            },
          },
        },
      ],
    };
    findItem(id, settings)
      .then((item) => {
        // Verifica se o item é privado e o usuário não tem permissão
        if (item.nivel === 'privado' && !getters.hasPermission) {
          Router.push({ name: 'Acervo listar' });
          notifyError('Você não tem permissão para acessar este acervo privado.');
          commit('setLoading', false);
          return;
        }
        // se estiver publicado, loga a consulta
        if (item.statusFluxo === 'EV') {
          Log.$api.create({
            operationType: 'Consulta',
            accountName: getters.account && getters.account.name.trim(),
            publicacaoName: item.nome,
            accountId: getters.account && getters.account.id,
            publicacaoId: item.id,
            idTipopublicacao: item.idTipoPublicacao,
            idSegmento: item.segmento && item.segmento.idSegmento,
            publicacaoFisicoDigital: item.suporteBase
            && item.suporteBase.reduce((acc, val) => {
              if (val.idTipoSuporte !== 82) { acc += 'físico;'; }
              if (val.idTipoSuporte === 82) { acc += 'digital;'; }
              return acc;
            }, ''),
            publicacaoLocalizacao:
              item.suporteBase
              && item.suporteBase.reduce(
                (acc, val) => (acc += `${val.localizacaoFisica.trim()}; `),
                '',
              ),
            publicacaoRegistro: `${item.suporteBase.length
              && item.suporteBase[0].registro1.trim()} ${item.suporteBase.length
              && item.suporteBase[0].registro2.trim()} ${item.suporteBase.length
              && item.suporteBase[0].extensao}`,
          });
        }
        if (item.statusFluxo === 'EX') {
          commit('setRejectedDialog', true);
          commit('setNotification', item.notificacoes[0]);
          commit('setAcervo', item.tipoPublicacao && item.tipoPublicacao.etapas);
        }
        commit('setItem', item);
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
        dispatch('highlight');
      });
  },
  highlight({ getters }) {
    if (getters.globalSearch) {
      const internalHighlighter = function (options) {
        const id = {
          container: 'container',
          tokens: 'tokens',
          all: 'all',
          token: 'token',
          className: 'className',
          sensitiveSearch: 'sensitiveSearch',
        };
        const tokens = options[id.tokens];
        const allClassName = options[id.all][id.className];
        const allSensitiveSearch = options[id.all][id.sensitiveSearch];

        function checkAndReplace(node, tokenArr, classNameAll, sensitiveSearchAll) {
          let nodeVal = node.nodeValue;
          const { parentNode } = node;
          let i;
          let j;
          let curToken;
          let myToken;
          let myClassName;
          let mySensitiveSearch;
          let finalClassName;
          let finalSensitiveSearch;
          let foundIndex;
          let begin;
          let matched;
          let textNode;
          let span;
          let isFirst;

          for (i = 0, j = tokenArr.length; i < j; i += 1) {
            curToken = tokenArr[i];
            myToken = curToken[id.token];
            myClassName = curToken[id.className];
            mySensitiveSearch = curToken[id.sensitiveSearch];

            finalClassName = classNameAll ? `${myClassName} ${classNameAll}` : myClassName;

            finalSensitiveSearch = typeof sensitiveSearchAll !== 'undefined' ? sensitiveSearchAll : mySensitiveSearch;

            isFirst = true;
            while (true) {
              if (finalSensitiveSearch) foundIndex = nodeVal.indexOf(myToken);
              else foundIndex = nodeVal.toLowerCase().indexOf(myToken.toLowerCase());

              if (foundIndex < 0) {
                if (isFirst) break;

                if (nodeVal) {
                  textNode = document.createTextNode(nodeVal);
                  parentNode.insertBefore(textNode, node);
                } // End if (nodeVal)

                parentNode.removeChild(node);
                break;
              } // End if (foundIndex < 0)

              isFirst = false;

              begin = nodeVal.substring(0, foundIndex);
              matched = nodeVal.substr(foundIndex, myToken.length);

              if (begin) {
                textNode = document.createTextNode(begin);
                parentNode.insertBefore(textNode, node);
              } // End if (begin)

              span = document.createElement('span');
              span.className += finalClassName;
              span.appendChild(document.createTextNode(matched));
              parentNode.insertBefore(span, node);

              nodeVal = nodeVal.substring(foundIndex + myToken.length);
            } // Whend
          } // Next i
        } // End Function checkAndReplace

        function iterator(p) {
          if (p === null) return;

          const children = Array.prototype.slice.call(p.childNodes);
          let i;
          let cur;

          if (children.length) {
            for (i = 0; i < children.length; i += 1) {
              cur = children[i];
              if (cur.nodeType === 3) {
                checkAndReplace(cur, tokens, allClassName, allSensitiveSearch);
              } else if (cur.nodeType === 1) {
                iterator(cur);
              }
            }
          }
        }

        iterator(options[id.container]);
      };
      internalHighlighter({
        container: document.getElementById('highlight'),
        all: {
          className: 'highlighter',
        },
        tokens: [
          {
            token: getters.globalSearch,
            className: 'highlight',
            sensitiveSearch: false,
          },
        ],
      });
    }
  },
  loadDocumentos({
    commit, state, rootState, getters,
  }, { $event }) {
    commit('setLoading', true);
    const settings = {
      where: {
        idPublicacao: rootState.route.params.id,
      },
      ...state.filter,
    };
    if (!getters.hasPermission) {
      settings.where.nivel = 'publico';
    }
    if ($event) {
      if ($event.itemsPerPage) {
        settings.limit = $event.itemsPerPage;
      }
      if ($event.page > 1) {
        settings.skip = ($event.page - 1) * $event.itemsPerPage;
      }
      if ($event.sortBy.length) {
        settings.order = `${$event.sortBy[0]} ${$event.sortDesc[0] ? 'ASC' : 'DESC'}`;
      }
      commit('setOptions', $event);
    }
    return findDocumentos(settings)
      .then((items) => {
        commit('setDocumentos', items.items);
        commit('setTotalDocumentos', items.total);
      })
      .catch(() => {
        commit('setLoading', false);
        notifyError();
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  clean({ commit }) {
    commit('setItem', {});
    commit('setDocumentos', []);
    commit('setTotalDocumentos', 0);
    commit('setRejectedDialog', false);
  },
  onApprove({ state, commit, dispatch }) {
    const { item } = state;
    item.statusFluxo = 'EV';
    commit('setLoading', true);
    updateItem(item)
      .then(notifySuccess('Item aprovado com sucesso.'))
      .then(() => {
        dispatch('clean');
        Router.push({ name: 'Acervo listar' });
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onReject({
    state, commit, dispatch, rootState,
  }, motive) {
    if (!motive) {
      notifyError('É obrigatório um motivo');
      return false;
    }
    const { item } = state;
    item.statusFluxo = 'EX';
    const notificacao = {
      idOperador: state.item.idSubmissao,
      explicacao: motive,
      idPublicacao: state.item.id,
      idAdmin: rootState.auth.account.id,
      tipo: 'recusado',
    };
    commit('setLoading', true);
    return updateItem(item)
      .then(() => createNotificacao(notificacao))
      .then(notifySuccess('Acervo recusado.'))
      .then(() => {
        dispatch('clean');
        Router.push({ name: 'Acervo listar' });
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onRejectedDialogInput({ commit }, event) {
    commit('setRejectedDialog', event);
  },
};

export default {
  namespaced: true,
  state: {
    loading: false,
    item: {},
    documentos: [],
    totalDocumentos: 0,
    options: {
      itemsPerPage: 6,
      page: 1,
      sortBy: ['id'],
      sortDesc: [true],
    },
    filter: {},
    rejectedDialog: false,
    notification: {},
    acervo: '',
  },
  mutations,
  getters: Getters,
  actions,
};
